import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { useAuth, homeForRole } from "../../context/AuthContext";
import { Logo } from "../../components/common";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(homeForRole(data.role));
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-[#F8FAFC]" data-testid="auth-splash">
      <Logo stacked className="animate-pulse" />
      <p className="text-sm text-slate-400">Signing you in…</p>
    </div>
  );
}
